import { useNavigate } from 'react-router-dom';

import { HeaderCTACard } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, SxProps, Typography, Theme } from '@mui/material';

const HEADER_STRINGS = appStrings.modules.lifeReadiness.header;

export const DashboardHeader = () => {
  const navigate = useNavigate();

  return (
    <Box sx={containerSx}>
      <HeaderCTACard
        title={HEADER_STRINGS.title}
        buttonText={HEADER_STRINGS.buttonText}
        buttonOnClick={() => navigate(`${APP_ROUTE.LIFE_READINESS}/quiz`)}
        imageUrl={'/images/quality-group.svg'}
      />

      <Box sx={textContainerSx}>
        <Typography
          variant="display-xs-semibold"
          color={({ backrs }) => backrs.colors['Colors/Text/text-primary']}
        >
          {HEADER_STRINGS.title}
        </Typography>

        <Typography
          variant="text-sm-regular"
          color={({ backrs }) => backrs.colors['Colors/Text/text-tertiary']}
        >
          {HEADER_STRINGS.description}
        </Typography>
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  mx: {
    lg: backrs.spacing['spacing-2xl'],
  },
  maxWidth: { lg: '936px' },
});

const textContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  pt: backrs.spacing['spacing-2xl'],
  pb: backrs.spacing['spacing-4xl'],
  pl: {
    xs: backrs.spacing['spacing-none'],
    sm: backrs.spacing['spacing-3xl'],
  },
  pr: {
    xs: backrs.spacing['spacing-none'],
    sm: backrs.spacing['spacing-3xl'],
    md: backrs.spacing['spacing-10xl'],
  },
  borderBottom: `1px solid ${backrs.colors['Beige/900']}`,
  mb: backrs.spacing['spacing-4xl'],
  gap: backrs.spacing['spacing-lg'],
});
